﻿const cookieTools = require('../../ga/scripts/partials/cookies');

$('.spg-ad-spot a, .spg-ad-spot').mouseenter(function () {
    $(this).closest('.spg-ad-spot').find('.spg-ad-spot-image-container').addClass('cta-hover');
}).mouseleave(function () {
    $(this).closest('.spg-ad-spot').find('.spg-ad-spot-image-container').removeClass('cta-hover');
});

$('.leasing-slider').slick({
    arrows: true,
    accessibility: false,
    dots: false,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1025,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});

if (cookieTools.read("businessLeasingDocsTermsAccepted") !== "true") {
    window.leasingModalId = '';
    window.clickedLeasingDocCard = null;

    function showTermsForm(e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(e.target).closest('.card[data-bs-target]').length > 0) {
            window.leasingModalId = $(e.target).closest('.card').attr('data-bs-target');
        } else {
            window.clickedLeasingDocCard = $(e.target).closest('.card');
        }

        bootstrap.Modal.getOrCreateInstance(document.getElementById('termsModal')).show();
    }

    $('.leasing-slider *[data-bs-toggle="modal"]').each((index, element) => {
        $(element).removeAttr('data-bs-toggle');
    });

    $('.leasing-slider a.card:not(.lease-inquiry-link), .leasing-slider button.card').on("click", (e) => showTermsForm(e));

    $('#termsModal form').on('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $.ajax({
            type: "GET",
            url: "/home/logdocsaccessagreement/",
            dataType: "text",
            encode: true,
        }).done(function (data) {
            if (data == "True") {
                cookieTools.write('businessLeasingDocsTermsAccepted', 'true', 180);
                $('.leasing-slider a.card:not(.lease-inquiry-link), .leasing-slider button.card').off('click', showTermsForm);
                bootstrap.Modal.getOrCreateInstance(document.getElementById('termsModal')).hide();

                $('.leasing-slider *[data-bs-target]').each((index, element) => {
                    $(element).attr('data-bs-toggle', 'modal');
                });

                if (window.leasingModalId) {
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(window.leasingModalId.replace('#', ''))).show();
                    window.leasingModalId = '';
                } else if (window.clickedLeasingDocCard) {
                    if ($(window.clickedLeasingDocCard).attr('href')) {
                        window.open($(window.clickedLeasingDocCard).attr('href'), '_blank');
                    } else {
                        $(window.clickedLeasingDocCard).trigger('click');
                    }
                }
            }
        });
    });
}

$('.spg-ad-spot-wide').each((i, e) => {
    if (e.getAttribute('href') && e.getAttribute('href').includes('vimeo.com')) {
        let vimeoUrl = '';

        if (e.getAttribute('href').includes('player.vimeo.com')) vimeoUrl = e.getAttribute('href').split('?')[0];
        else vimeoUrl = 'https://player.vimeo.com/video/' + e.getAttribute('href').split('/').pop().split('?')[0];

        $(e).addClass('spg-ad-spot-vimeo');

        if (!e.querySelector('.hero-middle-center, .hero-top-center, .hero-bottom-center')) {
            $(e).find('.spg-ad-spot-image-container').append(`
            <div class="spg-ad-spot-vimeo-play position-absolute top-50 start-50 translate-middle">
                <svg width="60" height="60" fill="#ffffff">
                    <use xlink:href="#icon-play"></use>
                </svg>
            </div>
        `);
        }

        if (!document.getElementById('vimeoModal' + i)) {
            var vimeoModal = document.createElement('div');
            vimeoModal.setAttribute('id', 'vimeoModal' + i);
            vimeoModal.setAttribute('class', 'modal');
            vimeoModal.innerHTML = `
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">

                      <div class="modal-header">
                        ${$(e).find('h2').text()}
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                      </div>

                      <div class="modal-body">
                        <div style="padding:56.25% 0 0 0;position:relative;">
                          <iframe id="vimeoPlayer${i}" src="${vimeoUrl}?autoplay=false&autopause=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
            `;

            document.body.append(vimeoModal);

            var modalEl = document.getElementById('vimeoModal' + i)
            modalEl.addEventListener('hidden.bs.modal', function (event) {
                const vimeoPlayer = new Vimeo.Player(document.getElementById('vimeoPlayer'+i));
                vimeoPlayer.pause();
            });
        }

        e.setAttribute('data-bs-toggle', 'modal');
        e.setAttribute('data-bs-target', '#vimeoModal' + i);

        let vimeoScript = document.createElement('script');

        if (!document.getElementById('vimeoSDK')) {
            vimeoScript.src = "https://player.vimeo.com/api/player.js";
            document.body.appendChild(vimeoScript);
        }
    }
});

//Lookup Aerial View video
if (aerialVideoId) {
    $.ajax({
        url: "https://aerialview.googleapis.com/v1/videos:lookupVideo?key=AIzaSyCyLgVAv7xLpMgQv1-jV26bkB4uI371CCs&videoId=" + aerialVideoId,
        success: (response) => {
            //Do stuff
            if (response.uris) {
                var aerialSection = document.getElementById('aerial-view-video-section');
                document.getElementById('aerial-view-section').classList.remove('d-none');
                var aerialVideo = document.createElement('video');
                aerialVideo.classList.add('img-full');
                aerialVideo.muted = true;
                aerialVideo.autoplay = true;
                aerialVideo.loop = true;
                aerialVideo.setAttribute('src', response.uris.MP4_HIGH.landscapeUri);
                aerialVideo.setAttribute('poster', response.uris.IMAGE.landscapeUri);

                aerialSection.appendChild(aerialVideo);

                const videoElement = aerialSection.getElementsByTagName('video')[0];

                document.getElementById('aerial-view-play').addEventListener('click', () => {
                    videoElement.play();
                    document.getElementById('aerial-view-play').style.display = 'none';
                    document.getElementById('aerial-view-pause').style.display = 'block';
                });
                document.getElementById('aerial-view-pause').addEventListener('click', () => {
                    videoElement.pause();
                    document.getElementById('aerial-view-play').style.display = 'block';
                    document.getElementById('aerial-view-pause').style.display = 'none';
                });
            }
        },
        error: () => {
            //No video found
        }
    });


}